import React from 'react';
import { Chip, Stack, Typography } from '@mui/material';

import { NamedEntity } from '../../../../types';

interface NamedEntityListProps {
  items: NamedEntity[] | null;
}

export const NamedEntityList = ({ items }: NamedEntityListProps) => {
  if (!items || !items.length) return <Typography color="error">No data</Typography>;

  return (
    <Stack gap="0.5rem">
      {items.map(item => (
        <Chip
          key={item.id}
          size="small"
          color="info"
          variant="outlined"
          label={<Typography sx={{ wordBreak: 'break-all' }}>{item.name}</Typography>}
        />
      ))}
    </Stack>
  );
};
